<div class="action" *ngFor="let action of actions" (click)="do(action)">
  <ion-icon [name]="action.icon" color="primary"></ion-icon>
  <div class="action-title">{{ action.title }}</div>
</div>
